import { effect, inject, Injectable, Signal, signal } from '@angular/core';
import { ProfileService } from '../profile/profile.service';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  private profileService = inject(ProfileService);

  private initialisedSignal = signal<boolean | undefined>(undefined);

  constructor() {
    effect(
      async () => {
        const initialised = this.profileService.initialised();
        if (initialised) {
          this.initialisedSignal.set(true);
        }
      },
      { allowSignalWrites: true },
    );
  }

  get initialised(): Signal<boolean | undefined> {
    return this.initialisedSignal.asReadonly();
  }

  reset() {
    this.initialisedSignal.set(undefined);
  }
}
